<template>
  <div class="header">
    <div class="field-narrow">{{ $t('number') }}</div>
    <div class="field-narrow">{{ $t('status') }}</div>
    <div class="field-medium">{{ $t('name') }}</div>
    <div class="field-medium">{{ $t('MAC') }}</div>
    <div class="field-medium">{{ $t('updateTime') }}</div>
    <div class="field-medium">{{ $t('operation') }}</div>
  </div>
</template>

<script>
export default {
};
</script>

<style>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}

</style>
